import React, { useState, useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import RankCss from '../../pages/css/RankCss';
import axios from 'axios';
import { MDBIcon, MDBBtn, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody } from 'mdb-react-ui-kit'
function AllotmentLetter(props) {

    // const [data,setData] = useState({})
    const [data, setData] = useState({})
    const getData = () => {
        axios.get('/api/v1/profile')
            .then(function (response) {
                // handle success
                setData(response.data.user)
                console.log(response.data.user)
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
    }

    
    useEffect(() => {
        getData()
    }, [])
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // modal open an close functionality
    const [fullscreenXlModal, setFullscreenXlModal] = useState(true);

    const toggleShow = () => setFullscreenXlModal(!fullscreenXlModal);
    return (
        <div>
            <MDBModal tabIndex='-1' show={fullscreenXlModal} setShow={setFullscreenXlModal}>
                <MDBModalDialog size='fullscreen-xxl-down'>
                    <MDBModalContent>
                        <MDBModalBody>
                            <div className='p-4 paymentPage' ref={componentRef}>
                                <RankCss>
                                    {
                                        data ? <>
                                            <div style={{ border: '2px solid gray', width: '720px', margin: 'auto' }} >
                                                <center className='flex justify-between items-center mb-4 mt-4 pl-2 pr-2' style={{ display: 'flex', justifyContent: 'space-between', margin: '4rem 0', padding: '0 2rem' }} width='720'>
                                                    <div>
                                                        <img style={{ width: '3.8rem' }} src='https://aicee.in/static/media/logo1.32bf711ad21b08f4f19d.png' alt='aicee' />
                                                    </div>
                                                    <div>
                                                        <h4 className='font-black text-[#e35d26]' style={{ color: '#e35d26' }}>All India Combined Entrance Examination 2023</h4>
                                                        <h5 className='font-bold text-[#e35d26] ' style={{ textDecoration: 'underline', marginTop: '0.8rem', color: '#e35d26' }}>Seat Allotment Letter</h5>
                                                    </div>
                                                    <div style={{ paddingRight: '1.5rem' }}>
                                                        {/* <img style={{width:'5rem'}} src='https://aicee.in/static/media/logo1.32bf711ad21b08f4f19d.png' alt='aicee'/> */}
                                                    </div>
                                                </center>
                                                <table border='1' width='718' cellPadding='6' className='mt-4'>
                                                    <tr>
                                                        <td width='200' className='heading font-bold'>
                                                            Application No
                                                        </td>
                                                        <td colSpan='3'>
                                                            {data.applicationNo}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='heading font-bold'>Student Name</td>
                                                        <td>{data.studentName}</td>
                                                        <td rowSpan='4' width='200' style={{ margin: 'auto' }}>
                                                            <img style={{ width: '8rem', margin: 'auto' }} src={data.photo} alt='img' />
                                                        </td>


                                                    </tr>
                                                    <tr>
                                                        <td className='heading font-bold'>Father's Name</td>
                                                        <td>{data.fatherName}</td>

                                                    </tr>
                                                    <tr>
                                                        {/* <td className='heading font-bold'>Mother's Name</td>
                                                        <td>{data.motherName}</td> */}
                                                    </tr>
                                                    <tr>
                                                        <td className='heading font-bold'>Mode Of Examination</td>
                                                        <td>HBE</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='heading font-bold'>Program Opted</td>
                                                        <td>{data.progOpted == "engg" ? "Engineering" : data.progOpted}</td>
                                                        <div cellPadding='none'>
                                                            <img style={{ width: '13rem', height: '2.3rem', padding: '-1rem' }} src={data.signature} alt='signature' />
                                                        </div>
                                                    </tr>
                                                    <tr>
                                                        <td className='heading font-bold'>Level Of Examination</td>
                                                        <td colSpan='3'>{data.loe}</td>
                                                    </tr>
                                                </table>
                                                {
                                                    data.allotedCollege && <>


                                                        <table border='1' width='718' cellPadding='6'>
                                                            <tr>
                                                                <td width='200' colSpan='5' className='heading' style={{ fontWeight: 'bolder', textAlign: 'center' }}>
                                                                    Allotment Details
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width='200' className='heading font-bold'>
                                                                    College Name
                                                                </td>
                                                                <td colSpan='3'>
                                                                    {data.allotedCollege[0].collegeName}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width='200' className='heading font-bold'>
                                                                    College Code
                                                                </td>
                                                                <td colSpan='3'>
                                                                    {data.allotedCollege[0].collegeCode}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width='200' className='heading font-bold'>
                                                                    State
                                                                </td>
                                                                <td colSpan='3'>
                                                                    {data.allotedCollege[0].state}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width='200' className='heading font-bold'>
                                                                    Program
                                                                </td>
                                                                <td colSpan='3'>
                                                                    {data.allotedCollege[0].programme}
                                                                </td>
                                                            </tr>
                                                            {
                                                                data.allotedCollege[0].branch && 
                                                            <tr>
                                                                <td width='200' className='heading font-bold'>
                                                                    Branch
                                                                </td>
                                                                <td colSpan='3'>
                                                                    {data.allotedCollege[0].branch}
                                                                </td>
                                                            </tr>
                                                            }
                                                            <tr>
                                                                <td width='200' className='heading font-bold'>
                                                                    Rank Used for Allottment
                                                                </td>
                                                                <td colSpan='3'>
                                                                    {data.rank}
                                                                </td>
                                                            </tr>

                                                        </table>
                                                    </>
                                                }
                                                {/* <table border='1' width='718' cellPadding='6'>
                                                    <tr>
                                                        <td width='200' colSpan='2' className='heading' style={{ fontWeight: 'bolder', textAlign: 'center' }}>
                                                            Rank
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width='350' className=''>
                                                            AICEE - 2023 Rank
                                                        </td>
                                                        <td colSpan='3'>
                                                            {data.rank}
                                                        </td>
                                                    </tr>


                                                </table> */}

                                                <div>
                                                    {/* <p style={{ fontSize: '12px', padding: '5px' }}>
                                                        AICEE Scores are normalized scores across multi session papers and are based on the relative performance of all those who appeared for the examination in one session
                                                    </p> */}
                                                    <p style={{ fontSize: '12px', padding: '5px', marginTop: '10px' }}>
                                                        <strong> Dear candidate,</strong> <br></br>
                                                        Based on your Rank and Choices of program you have been provisionally Allotted a seat. Report to the Allotted institution as per reporting instructions of AICEE ( Which will be published after 3rd round of AICEE Counselling).
                                                    </p>
                                                    <p style={{ fontSize: '12px', padding: '5px', marginTop: '-1rem' }}>
                                                        <strong>
                                                            List of Documents to be carried at the time of Reporting to the Allotted Institution.
                                                        </strong>
                                                        <li>Seat Allotment letter.</li>
                                                        <li>Payment Receipt of seat Acceptance fee.</li>
                                                        <li>Aadhar Card</li>
                                                        <li>Passport size photo – 10</li>
                                                        <li>Class Xth Marksheet certificate.</li>
                                                        <li>Class Xth Marksheet (or equivalent).</li>
                                                        <li>Residential Certificate or Domicile Certificate.</li>
                                                        <li>Income certificate of parent if their Annual Income is less than 4 lakhs.</li>
                                                        {/* <li></li> */}
                                                    </p>
                                                    <div style={{ fontSize: '10px', padding: '3px',textAlign:'justify' }}>
                                                        <span className='text-red-500' style={{ color: 'red', }}> Note :-</span>

                                                        {/* Reporting to the Allotted Institution will begin from 7th Aug 2023, (tentative) . */} &nbsp;
                                                        
                                                        This is not the Final Allotment. For Final Allotment students need to submit all the required Documents mentioned above or as per requirement of respective Institution or <span style={{fontWeight:'bold'}}>AICEE</span> (Within a given Time Frame). Some Institutions might also Conduct Aptitude Test or Personal Interview Round or Both before the Final Allotment. Under some unavoidable condition institution and AICEE have the right to cancel student's provisional Admission (Before reporting and Payment of First year complete fee ) Studnts have .
                                                         <br></br>
                                                         

                                                        {/*  */}
                                                    </div>
                                                    <center style={{ fontSize: '12px', padding: '1px', backgroundColor: '#ececec', marginTop: '0.5rem' }}>
                                                        For support call: +91 7488661870 or write us a Mail on <strong>Info@aicee.in</strong> or <strong>aicee.info@gmail.com</strong> .
                                                        <br></br>

                                                        Visit official AICEE website: <strong>www.aicee.in</strong> Regularly for more updates.
                                                    </center>
                                                </div>

                                            </div>
                                        </> : null
                                    }
                                </RankCss>
                                <center>
                                    <button onClick={handlePrint} style={{ backgroundColor: '#042e2e' }} className='pl-4 pr-4 pt-1 mt-5 text-white pb-1 rounded-md mt-2'><i class="fas fa-print"></i> &nbsp; Print / Download</button> &nbsp; &nbsp;
                                    {/* <button onClick={props.setLetter(false)} style={{ backgroundColor: '#042e2e' }} className='pl-4 pr-4 pt-1 mt-5 text-white pb-1 rounded-md mt-2'>  Close</button> */}
                                    <button onClick={() => { setFullscreenXlModal(!fullscreenXlModal) }} color='success' style={{ backgroundColor: 'gray', color: 'white', padding: '4px 12px', borderRadius: '8px' }}>Close</button>&nbsp; &nbsp;
                                </center>
                            </div>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    )
}

export default AllotmentLetter